import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { appReducer, AppState } from 'cdx-common';
import localforage from 'localforage';
import { Reducer } from 'redux';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE
} from 'redux-persist';
import persistReducer from 'redux-persist/es/persistReducer';
import persistStore from 'redux-persist/es/persistStore';

let preloadedState: any = undefined;
try {
    // @ts-ignore
    preloadedState = (window as unknown as any).__PRELOADED_STATE__;
} catch (ReferenceError) {
    // ne rien faire, c'est le backend qui s'exécute !
}

localforage.config({
    driver: localforage.LOCALSTORAGE, // Force WebSQL; same as using setDriver()
    name: 'cdx',
    version: 1.0,
    size: 4980736, // Size of database, in bytes. WebSQL-only for now.
    storeName: 'cdx_cache', // Should be alphanumeric, with underscores.
    description: 'CDX Data Cache'
});
const webPersistorConfig = {
    key: 'persist',
    storage: localforage,
    /*transforms: [tranform]*/
    whitelist: ['deviceStore']
};

const persistedWebReducer: Reducer<any, any> = persistReducer(webPersistorConfig, appReducer);

const configureWebStore = () => configureStore({
    reducer: persistedWebReducer,
    preloadedState: preloadedState,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
});

const webStore = configureWebStore();
const webPersistor = persistStore(webStore);

const generateNewId = (): LocalId => {
    const r = crypto.randomUUID();
    return `~${r}`;
};

export { AppState, webStore as appStore, generateNewId, webPersistor as persistor, AppState as RootState };

setupListeners(webStore.dispatch);
